import axios from 'axios';

const endpoint = process.env.VUE_APP_AWS_BACKEND_USERS_API_ENDPOINT;
// const endpoint = 'https://stg-api.yeah.ki-group.jp';

const getAccessLogs = async (userId, page = 1) => {
  const options = {
    headers: {
      'X-USER': userId,
    },
  };
  const response = await axios.get(`${endpoint}/site-access-logs?page=${page}`, options);
  return response.data;
};

const postAccessLogs = async (userId, body) => {
  const options = {
    headers: {
      'X-USER': userId,
    },
  };
  const response = await axios.post(`${endpoint}/site-access-logs`, body, options);
  return response;
};

const postHistoricalAccessLog = async (userId, body) => {
  const options = {
    headers: {
      'X-USER': userId,
    },
  };
  const response = await axios.post(`${endpoint}/site-access-logs-history`, body, options);
  return response;
};

const deleteAccessLog = async (userId, propertyId) => {
  const options = {
    headers: {
      'X-USER': userId,
    },
  };
  const response = await axios.delete(`${endpoint}/site-access-logs/${propertyId}`, options);
  return response;
};

const deleteAllAccessLogs = async (userId) => {
  const options = {
    headers: {
      'X-USER': userId,
    },
  };
  const response = await axios.delete(`${endpoint}/site-access-logs`, options);
  return response;
};

const getQueryLogs = async (userId, page = 1) => {
  const options = {
    headers: {
      'X-USER': userId,
    },
  };
  const response = await axios.get(`${endpoint}/site-query-logs?page=${page}`, options);
  return response.data;
};

const postQueryLogs = async (userId, body) => {
  const options = {
    headers: {
      'X-USER': userId,
    },
  };
  const response = await axios.post(`${endpoint}/site-query-logs`, body, options);
  return response;
};

const postQueryLogsHistorical = async (userId, body) => {
  const options = {
    headers: {
      'X-USER': userId,
    },
  };
  const response = await axios.post(`${endpoint}/site-query-logs-history`, body, options);
  return response;
};

const deleteQueryLog = async (userId, logId) => {
  const options = {
    headers: {
      'X-USER': userId,
    },
  };
  const response = await axios.delete(`${endpoint}/site-query-logs/${logId}`, options);
  return response;
};

const deleteAllQueryLogs = async (userId) => {
  const options = {
    headers: {
      'X-USER': userId,
    },
  };
  const response = await axios.delete(`${endpoint}/site-query-logs`, options);
  return response;
};

const retrieveWishList = async (userId, page = 1) => {
  const options = {
    headers: {
      'X-USER': userId,
    },
  };
  const response = await axios.get(`${endpoint}/site-wish-list?page=${page}`, options);
  return response.data;
};

const postWishList = async (userId, body) => {
  const options = {
    headers: {
      'X-USER': userId,
    },
  };
  const response = await axios.post(`${endpoint}/site-wish-list`, body, options);
  return response;
};

const putWishList = async (userId, id, body) => {
  const options = {
    headers: {
      'X-USER': userId,
    },
  };
  const response = await axios.put(`${endpoint}/site-wish-list/${id}`, body, options);
  return response;
};

const deleteWishList = async (userId, propertyId) => {
  const options = {
    headers: {
      'X-USER': userId,
    },
  };
  const response = await axios.delete(`${endpoint}/site-wish-list/${propertyId}`, options);
  return response;
};

const getLastSearchedArea = async (userId) => {
  const options = {
    headers: {
      'X-USER': userId,
    },
  };
  const response = await axios.get(`${endpoint}/site-last-searched-area`, options);
  return response.data.data;
};

export {
  getAccessLogs,
  postAccessLogs,
  deleteAccessLog,
  deleteAllAccessLogs,
  getQueryLogs,
  postQueryLogs,
  deleteQueryLog,
  deleteAllQueryLogs,
  retrieveWishList,
  postWishList,
  putWishList,
  deleteWishList,
  postHistoricalAccessLog,
  postQueryLogsHistorical,
  getLastSearchedArea,
};
